import { NavLink } from "react-router";
import "./Navbar.css";

export default function DownNavbar() {
  return (
    <nav
      className="navbar navbar-expand-lg"
      style={{ backgroundColor: "#1e3a5f" }}
    >
      <div className="container-fluid">
        <div className="w-75 m-auto">
          <div className="d-flex justify-content-between align-items-center">
            <button
              className="bg-white rounded navbar-toggler btn-ouline-light"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <form className="d-lg-none" role="search">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-search text-white"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                </svg>
              </div>
            </form>
          </div>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive
                      ? "active nav-link text-warning"
                      : "inactive nav-link text-white"
                  }
                >
                  HOME
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/about"
                  className={({ isActive }) =>
                    isActive
                      ? "active nav-link text-warning"
                      : "inactive nav-link text-white"
                  }
                >
                  ABOUT
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/editor-in-chief"
                  className={({ isActive }) =>
                    isActive
                      ? "active nav-link text-warning"
                      : "inactive nav-link text-white"
                  }
                >
                  EDITOR IN CHIEF
                </NavLink>
              </li>
              <li className="nav-item dropdown">
                <NavLink
                  to="/board"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  className={({ isActive }) =>
                    isActive
                      ? "nav-link dropdown-toggle text-warning"
                      : "nav-link dropdown-toggle text-white"
                  }
                >
                  BOARD
                </NavLink>
                <ul className="dropdown-menu">
                  <li>
                    <NavLink
                      to="/board/editorial-board"
                      className={({ isActive }) =>
                        isActive ? "dropdown-item bg-warning" : "dropdown-item"
                      }
                    >
                      Editorial Board
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/board/why-rd"
                      className={({ isActive }) =>
                        isActive ? "dropdown-item bg-warning" : "dropdown-item"
                      }
                    >
                      Why Publish with RD
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/board/publication-criteria"
                      className={({ isActive }) =>
                        isActive ? "dropdown-item bg-warning" : "dropdown-item"
                      }
                    >
                      Publications Criteria
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle text-white"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  SUBMISSION
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <a className="dropdown-item" href="#">
                      Paper Submission Guidline
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Submit Menuscript
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Book Submission Guidline
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <a className="nav-link text-white" href="#">
                  BOOK
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link text-white" href="#">
                  ARCHIVE
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link text-white" href="#">
                  GALLERY
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link text-white" href="#">
                  CONTACT US
                </a>
              </li>
            </ul>

            <form className="" role="search">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-search text-white"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                </svg>
              </div>
            </form>
          </div>
        </div>
      </div>
    </nav>
  );
}
